/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import {
  Tooltip,
  Popconfirm,
  Radio,
  Space,
  Button,
  message,
  Select,
} from "antd";
import React, { useState } from "react";
import bookingDownload from "../../../assests/images/bookingDownload.svg";
import downArrow from "../../../assests/images/downArrow.png";

import editIcon from "../../../assests/images/edit-logo.svg";
import disable_icon from "../../../assests/images/SVG/disable.svg";

import print_icon from "../../../assests/images/printIcon.svg";
import hardware_print_icon from "../../../assests/images/hardwarePrinter.png";

import useCustomNavigate from "../../../components/customNavigationHook";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { FilterFilled } from "@ant-design/icons";

// Filters

import "antd/dist/antd.css";

import {
  capitaliseWithHyphen,
  commonSorterForTable,
  normalizeService,
  normalizeString,
  serialNum,
} from "../../../utils";
import "./style.scss";
import urls from "../../../api/urls";
import API from "../../../api";
// import Filters from "./Filters";

export const column = (
  MyComponent,
  statusFun,
  handleEdit,
  handleEditView,
  handleUpload,
  handleEyeButton,
  pageSize,
  pageNum,
  handleCancel = () => { },
  printCallBack = () => { },
  printerCallBack = () => { },
  printPDFLabel = () => { },
  filteredInfo,
  clearFilters,
  setLoadTable = () => { },
  creditPrint = () => { },
  userList
) => {
  const navigate = useCustomNavigate();
  const currentEnv = process.env.REACT_APP_ENV;

  const { GET_ALL_STAFF, PRINT_RETAIL_INVOICE } = urls;

  // const enableEdit = localStorage.getItem("editCredit");
  const enableEdit = "true";

  // const shipmentType = [
  //   {
  //     value: "standard",
  //     text: "STANDARD",
  //   },
  //   {
  //     value: "fast track",
  //     text: "FAST TRACK",
  //   },
  //   {
  //     value: "valueplus",
  //     text: "VALUE PLUS",
  //   },
  // ];
  const bookingType = [
      {
          value: "account",
          text: "CREDIT",
      },
      {
          value: "retail",
          text: "RETAIL",
      },
      // {
      //   value: "both",
      //   text: "BOTH",
      // },
  ];
  // console.log(filteredInfo, "filter");

  const DocType = [
      {
          value: "dox",
          text: "DOX",
      },
      {
          value: "non-dox",
          text: "NON-DOX",
      },
  ];


  const shipmentMode = [
      {
          value: currentEnv == "qa" ? "Air" : "air",
          text: "AIR",
      },
      {
          value: currentEnv == "qa" ? "Surface" : "surface",
          text: "SURFACE",
      },
  ];

  const shipmentstatus = [
      {
          value: "MANIFESTED",
          text: "MANIFESTED",
      },
      {
          value: "BOOKED",
          text: "BOOKED",
      },
  ];

  const [filterState, setFilterState] = useState(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
      if (dataIndex === "users") {
          setFilterState(selectedKeys?.[0] || null);
      }
  };

  const [docType, setDocType] = React.useState([]);
  const [shipmentType, setShipmentType] = React.useState([]);

  const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({ setSelectedKeys, confirm, clearFilters, visible }) => {
          const [previousVisible, setPreviousVisible] = React.useState(false);

          React.useEffect(() => {
              if (!visible && previousVisible) {
                  setSelectedKeys([
                      docType?.length > 0 ? docType[0] : null,
                      shipmentType?.length > 0 ? shipmentType[0] : null,
                  ]);
                  confirm();
              }
              setPreviousVisible(visible);
          }, [visible]);

          const handleReset = () => {
              setDocType([]);
              setShipmentType([]);
              clearFilters && clearFilters();
          };

          return (
              <div
                  style={{
                      padding: 8,
                  }}
                  className="view-booking-filter-dropdown"
                  onKeyDown={(e) => e.stopPropagation()}
              >
                  <strong> Doc Type</strong>
                  <div>
                      <Radio.Group
                          value={docType[0]}
                          onChange={(e) => {
                              setDocType([e.target.value]);
                          }}
                      >
                          <Space direction="vertical" style={{ gap: "2px !important" }}>
                              <Radio value="DOX">DOX</Radio>
                              <Radio value="NON-DOX">NON-DOX</Radio>
                          </Space>
                      </Radio.Group>
                  </div>
                  <br />
                  <strong>Service Type</strong>
                  <div>
                      <Radio.Group
                          value={shipmentType[0]}
                          onChange={(e) => {
                              setShipmentType([e.target.value]);
                          }}
                      >
                          <Space direction="vertical" style={{ gap: "2px" }}>

                              <>
                                  {/* Standard, Fastrack, Value Plus, SDD, NDD, vayuQuick, vayuQuickPro */}
                                  <Radio value="Standard">STANDARD</Radio>
                                  <Radio value="Fastrack">FAST TRACK</Radio>
                                  <Radio value="Value Plus">VALUE PLUS</Radio>
                                  <Radio value="vayuQuick">VAYU QUICK</Radio>
                                  <Radio value="vayuQuickPro">VAYU QUICK PRO</Radio>
                              </>

                          </Space>
                      </Radio.Group>
                  </div>
                  <br />
                  {/* Action Buttons */}
                  <div style={{ textAlign: "right" }}>
                      <Button
                          onClick={handleReset}
                          size="small"
                          style={{ width: 90, marginRight: 8 }}
                      >
                          Reset
                      </Button>
                      <Button
                          type="primary"
                          onClick={() => {
                              setSelectedKeys([
                                  docType?.length > 0 ? docType[0] : null,
                                  shipmentType?.length > 0 ? shipmentType[0] : null,
                              ]);
                              confirm();
                          }}
                          size="small"
                          style={{ width: 90 }}
                      >
                          OK
                      </Button>
                  </div>
              </div>
          );
      },

      filterIcon: (filtered) => {
          const type = filteredInfo?.type || [null, null];
          const isFilterNull = type[0] == null && type[1] == null;

          return (
              <FilterFilled
                  style={{
                      color: type[0] == null && type[1] == null ? undefined : "#1890ff",
                  }}
              />
          );
      },
  });

  const formatText = (name, charLength = 15) => {
      if (!name) return "N/A";
      return (
          <>
              {name?.length > charLength ? (
                  <Tooltip title={name} placement="bottom">
                      {name?.length > charLength
                          ? `${name?.substring(0, charLength)}..`
                          : name}
                  </Tooltip>
              ) : (
                  name
              )}
          </>
      );
  };

  // console.log(filteredInfo, "filteredInfo");

  const getColumnUserProps = (dataIndex, list) => ({
      filterDropdown: ({ setSelectedKeys, confirm, selectedKeys }) => (
          <div
              style={{
                  padding: 8,
              }}
              onKeyDown={(e) => e.stopPropagation()}
          >
              <Select
                  onSelect={(e) => {
                      setSelectedKeys([e]);
                      confirm();
                      // handleUserFilter(e, confirm);
                  }}
                  filterOption={(input, option) =>
                      (option?.label ?? "")?.toLowerCase()?.includes(input?.toLowerCase())
                  }
                  onSearch={(e) => handleSearch([e], confirm, dataIndex)}
                  showSearch
                  allowClear
                  onClear={() => {
                      setSelectedKeys(null);
                      confirm();
                  }}
                  placeholder={"Select user"}
                  options={list}
                  style={{
                      marginBottom: 8,
                      width: "200px",
                      display: "block",
                  }}
              />
          </div>
      ),
      filterIcon: (filtered) => {
          const type = filteredInfo?.userName || [null];
          const isFilterNull = type[0] == null;

          return (
              <FilterFilled
                  style={{
                      color: isFilterNull ? undefined : "#1890ff",
                  }}
              />
          );
      },
  });

  const cashPrint = async (id) => {
      setLoadTable(true);
      let response = await API.Api(
          PRINT_RETAIL_INVOICE + id
      ).getWithUserNPremiseHeader();
      if (response?.status) {
          setLoadTable(false);
          let data = response?.response?.data?.data;

          data?.invoiceUrl
              ? window.open(data?.invoiceUrl)
              : message.error("Internal server error.");
      } else {
          setLoadTable(false);
          message.error(
              response?.response?.data?.message || "Internal server error."
          );
      }
  };

  return [
      {
          title: "SI",
          width: 60,
          dataIndex: "sl",
          fixed: "left",
          align: "center",

          render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
      },

      {
          title: (
              <>
                  <span>
                      Document <br /> Number
                  </span>
              </>
          ),
          dataIndex: "awbNumber",
          key: "awbNumber",
          className: "awbNumber",
          fixed: "left",
          width: 115,
          sorter: {
              compare: (a, b) => a?.awbNumber - b?.awbNumber,
          },
          render: (text, record) => {
              return (
                  <div>
                      <div>
                          <a onClick={() => handleEyeButton(record)}>{text} </a>
                      </div>
                      {record?.childCount !== 0 && record?.childCount && (
                          <div
                              style={{
                                  color: "#09A70C",
                                  /* background: red; */
                                  display: "inline",
                                  padding: " 2px 7px",
                                  border: " 1px solid #09A70C",
                                  borderRadius: "10px",
                                  background: " #d3ffd3",
                              }}
                          >
                              {"+" + record?.childCount + " Child"}
                          </div>
                      )}
                  </div>
              );
          },
      },

      {
          title: (
              <>
                  <span>
                      Booking <br /> Type
                  </span>
              </>
          ),
          dataIndex: "bookingType",
          key: "bookingType",
          width: 70,
          // sorter: true,
          render: (text, b) => text?.toUpperCase(),
      },
      {
          title: (
              <>
                  <span>
                      Sender <br /> Name
                  </span>
              </>
          ),
          dataIndex: "senderName",
          key: "senderName",
          width: 130,
          // sorter: true,
          render: (text, b) => formatText(text, 25),
      },
      {
          title: (
              <>
                  <span>
                      Receiver <br /> Name
                  </span>
              </>
          ),
          dataIndex: "receiverName",
          key: "receiverName",
          width: 80,
          render: (text, b) => formatText(capitaliseWithHyphen(text), 15),
          // render: (text, val) => capitaliseWithHyphen(text) || "N/A",/
      },
      {
          title: "To City",
          dataIndex: "toCenter",
          key: "toCenter",
          // ellipsis: true,
          width: 70,
          render: (text, b) => formatText(capitaliseWithHyphen(text), 15),
      },

      // {
      //   title: "Book Type",
      //   width: 65,
      //   dataIndex: "bookingType",
      //   key: "bookingType",
      //   filteredValue: filteredInfo?.bookingType || null,
      //   // ellipsis: false,
      //   filters: bookingType,
      //   filterMultiple: false,

      //   render: (text) =>
      //     text?.toUpperCase() === "ACCOUNT" ? "Credit" : "Retail",
      // },

      {
          title: "Type & Service",
          dataIndex: "type",
          filters: DocType,
          ...getColumnSearchProps("type"),
          filteredValue: docType || shipmentType || null,
          // ellipsis: true,
          filterMultiple: false,
          key: "type",
          width: 105,
          render: (text, val) => {
              return (
                  <>
                      {capitaliseWithHyphen(text)}
                      <br />
                      {capitaliseWithHyphen(normalizeService(val?.serviceType))}
                  </>
              );
          },
      },
      {
          title: "Mode",
          dataIndex: "travelBy",
          key: "travelBy",
          // ellipsis: false,
          width: 65,
          filters: shipmentMode,
          filteredValue: filteredInfo?.travelBy || null,

          filterMultiple: false,
          render: (text, val) => capitaliseWithHyphen(text) || "N/A",
      },
      {
          title: (
              <>
                  <span>
                      Weight <br /> L * W * H
                  </span>
              </>
          ),
          dataIndex: "weight",
          key: "weight",
          align: "center",
          ellipsis: false,
          width: 80,
          render: (text, val) => {
              return (
                  <div>
                      <div style={{ textAlign: "center" }}>
                          {capitaliseWithHyphen(text) || "N/A"}
                      </div>
                      {val?.type?.toUpperCase() !== "DOX" && (
                          <div style={{ fontSize: "10px" }}>
                              {`${val?.length || 0} * ${val?.width || 0} * ${val?.height || 0
                                  }`}
                          </div>
                      )}
                  </div>
              );
          },
      },

      {
          title: (
              <>
                  <span>
                      Audited <br /> Weight
                  </span>
              </>
          ),
          dataIndex: "auditedWeight",
          key: "auditedWeight",
          align: "center",
          ellipsis: false,
          width: 60,
          render: (text, val) => text || 0,
      },
      // {
      //   title: (
      //     <>
      //       <span>
      //         Charges <br />
      //       </span>
      //     </>
      //   ),
      //   dataIndex: "totalCharge",
      //   key: "totalCharge",
      //   align: "center",
      //   ellipsis: true,
      //   width: 65,
      //   render: (text, val) => text || "N/A",
      // },

      {
          title: "Status",
          dataIndex: "bookingStatus",
          key: "bookingStatus",
          filters: shipmentstatus,
          filteredValue: filteredInfo?.bookingStatus || null,
          filterMultiple: false,
          ellipsis: true,
          // ellipsis: false,
          width: 70,
          // render: (text) => statusFun(text),
          render: (status) => (
              <span key={status}>{statusFun(normalizeString(status)) || "N/A"}</span>
          ),
      },
      {
          title: "Date",
          width: 80,
          dataIndex: "bookingTime",
          // ellipsis: true,
          key: "bookingTime",
          render: (text, b) => MyComponent(text),
      },


      {
          title: (
              <>
                  <span>Action</span>
                  {filteredInfo &&
                      Object.values(filteredInfo)?.some(
                          (value) =>
                              value !== null &&
                              (!Array.isArray(value) || value?.some((v) => v !== null))
                      ) && (
                          <span
                              style={{
                                  color: "#1890ff",
                                  marginLeft: "8px",
                                  cursor: "pointer",
                              }}
                              onClick={clearFilters}
                          >
                              Reset
                          </span>
                      )}
              </>
          ),
          align: "center",
          width: 100,
          fixed: "right",

          render: (a, record) => {
              // const currentEnv = process.env.REACT_APP_ENV;

              // let enabled =
              //   record?.bookingType?.toUpperCase() === "ACCOUNT" &&
              //   record?.bookingStatus === "BOOKED" &&
              //   currentEnv == "qa";

              return (
                  <div
                      style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          columnGap: "5px",
                          cursor: "pointer",
                          alignItems: "center",
                          marginBottom: 0,
                      }}
                  >
                      {/* <Tooltip
                          title={enableEdit == "true" ? "Edit" : null}
                          placement="left"
                      >
                          <p
                              className="vbooking-icons"
                              style={{
                                  cursor: enableEdit == "true" ? "pointer" : "not-allowed",
                              }}
                          >
                              <img
                                  src={editIcon}
                                  style={{ width: "22px", height: "20px" }}
                                  onClick={(e) => {
                                      if (enableEdit == "true") {
                                          e.preventDefault();

                                          handleEdit(record?.awbNumber, record?.bookingTime);
                                      } else {
                                          e.preventDefault();
                                      }
                                  }}
                              />
                          </p>
                      </Tooltip> */}
                      <Tooltip title={"Print receipt"} placement="left">
                          <p
                              className="vbooking-icons"
                              style={{
                                  cursor: "pointer",
                              }}
                          >
                              <img
                                  src={print_icon}
                                  style={{ width: "22px", height: "20px" }}
                                  onClick={(e) => {
                                      // currentEnv === "qa"
                                      //   ? navigate("/print-booking/" + record?.awbNumber)
                                      //   : printCallBack(record?.awbNumber);
                                      record.bookingType?.toLowerCase() === "retail"
                                          ? cashPrint(record?.awbNumber)
                                          : //: navigate("/print-booking/" + record?.awbNumber);
                                          creditPrint(record?.awbNumber);
                                  }}
                              />
                          </p>
                      </Tooltip>


                      {/* <Tooltip title={enabled ? "Upload" : null} placement="right">
              <p
                onClick={(e) => {
                  e.preventDefault();
                  handleUpload(a);
                }}
                className="vbooking-icons"
              >
                <img
                  src={bookingDownload}
                  style={{ width: "22px", height: "20px" }}
                />
              </p>
            </Tooltip> */}
                      {/* CODE COMMENTED TO CANCEL BOOKING */}
                      {/* <Tooltip
              title={enabled ? "Cancel booking" : null}
              placement="right"
            >
              <p className="vbooking-icons">
                <Popconfirm
                  title={
                    <span
                      className="test"
                      style={{
                        textTransform: "initial",
                      }}
                    >
                      Would you like to cancel this booking?
                    </span>
                  }
                  cancelText="NO"
                  okText="CONFIRM"
                  icon={
                    <QuestionCircleOutlined
                      style={{
                        color: "red",
                      }}
                    />
                  }
                  onConfirm={() => handleCancel(record?.awbNumber)}
                >
                  <img
                    src={disable_icon}
                    style={{ width: "22px", height: "20px" }}
                  />
                </Popconfirm>
              </p>
            </Tooltip> */}
                      <Tooltip title={"Printer thermal sticker"} placement="right">
                          <p
                              className="vbooking-icons"
                              style={{ marginTop: "-5px" }}
                              onClick={(e) => {
                                  printerCallBack(record?.awbNumber);
                              }}
                          >
                              <img
                                  src={hardware_print_icon}
                                  style={{ width: "12px", height: "12px" }}
                              />
                          </p>
                      </Tooltip>
                      <Tooltip title={"Print PDF"} placement="right">
                          <p
                              className="vbooking-icons"
                              style={{ marginTop: "-5px" }}
                              onClick={(e) => {
                                  printPDFLabel(record);
                              }}
                          >
                              <img
                                  src={downArrow}
                                  style={{ width: "12px", height: "12px" }}
                              />
                          </p>
                      </Tooltip>
                  </div>
              );
          },
      },
  ];
};
